<template>
    <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
        <Title :title="{name: '我的外出',path: '/my/outReport/record'}"></Title>
        <div style="margin: 10px auto;">
            <el-card class="box-card">
                <el-row :gutter="10" style="margin-left: 10px;">
                    <el-col :span="5">
                        <el-input placeholder="请输入项目名称" type="text" v-model="qparam.projectName" clearable>
                        </el-input>
                    </el-col>
                    <el-col :span="9">
                        <el-date-picker
                                v-model="qparam.createTimeArr"
                                value-format="yyyy-MM-dd"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="5">
                        <el-button icon="el-icon-refresh-left" type="primary" @click="resetQparam">重置</el-button>
                        <el-button icon="el-icon-search" type="primary" @click="search">查询</el-button>
                    </el-col>
                </el-row>
            </el-card>
        </div>

        <div style="margin: 10px auto;  ">
            <el-card class="box-card" style="min-height: 650px;">
                <el-table
                        :data="tableData"
                        style="width: 100%">
                    <el-table-column
                            prop="outAddress"
                            label="外出地点"
                    />
                    <el-table-column
                            label="外出事由"
                            prop="outSubject"
                    />
                    <el-table-column
                            label="外出人员"
                    >
                        <template v-slot="scope">
                            <span v-if="scope.row.users">
                                <span>{{scope.row.users}}</span>
                            </span>
                            <el-button type="text" v-else @click="getOutUsers(scope.row)">点击获取</el-button>
                        </template>

                    </el-table-column>
                    <el-table-column
                            label="所挂项目"
                    >
                        <template v-slot="scope">
                            <span v-if="scope.row.hasProject  === 1">
                                <br/>
                                <span>{{scope.row.projectName}}</span>
                            </span>
                            <el-tag type="danger" v-if="scope.row.hasProject  === 2">其他外出</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="外出开始时间"
                            prop="outBegainTime"
                    />
                    <el-table-column
                            label="外出结束时间"
                            prop="outEndTime"
                    />
                </el-table>
                <div style="margin: 40px auto; width: 30%;">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="currentPageChangeEvent"
                            :current-page="qparam.current"
                            :page-sizes="[10, 20, 50]"
                            :page-size="qparam.size"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalElements"
                    >
                    </el-pagination>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
    import {AesDecrypt} from "@/util";
    import {requestOutList,requestGetOutUsers} from "@/api";
    import Title from "@/components/Title.vue";
    export default {
        name: "allout",
        components: {Title},
        data() {
            return {
                tableData: [],
                totalElements: 0,
                qparam:{
                    current: 1,
                    size: 10,
                    userName: '',
                    projectName: '',
                    createTimeArr: [],
                    address: '',
                    month: ''
                },
                apply: {},
            }
        },
        methods: {
            async getOutUsers(row){
                const  res = await requestGetOutUsers({outId:row.outReportId});
                if(res.code === 200){
                    row.users = res.object.toString();
                }else{
                    this.$message.error(res.msg);
                }
            },
            handleSizeChange(size) {
                this.qparam.current = 1;
                this.qparam.size = size;
                this.initTableData()
            },
            resetQparam() {
                //this.qparam.userName = ''
                this.qparam.projectName = ''
                this.qparam.createTimeArr = []
                this.qparam.address = ''
                this.qparam.startTime = ''
                this.qparam.endTime = ''
                this.qparam.month = ""
                this.initTableData();
                window.location.href=""
            },
            currentPageChangeEvent(currentPage) {
                this.qparam.current = currentPage;
                this.initTableData()
            },
            async search() {
                this.qparam.current = 1;
                this.qparam.startTime = ''
                this.qparam.endTime = ''
                await this.initTableData()
            },
            async initTableData() {
                if(this.qparam.createTimeArr && this.qparam.createTimeArr.length > 0){
                    this.qparam.startTime = this.qparam.createTimeArr[0]
                    this.qparam.endTime = this.qparam.createTimeArr[1]
                }
                const createTimeArr = this.qparam.createTimeArr;
                this.qparam.createTimeArr = "";
                const res = await requestOutList(this.qparam);
                if(res.code === 200){
                    this.totalElements = res.total;
                    this.tableData = res.rows
                }else{
                    this.$message.error(res.msg)
                }
                this.qparam.createTimeArr = createTimeArr;
            }
        },
        created() {
            const user = JSON.parse(AesDecrypt(window.localStorage.getItem("user")))
            this.qparam.userName = user.realName
            this.initTableData()
        }
    }
</script>

<style scoped>

</style>
